import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueAliplayer from '@/components/live/VueAliplayer.vue';
export default {
  name: 'DoQuestionBzAswer',
  props: {
    questionInfo: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      zmArr: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  components: {
    "ali-player": VueAliplayer
  },
  computed: {
    bzAnswerInfo: function bzAnswerInfo() {
      var _this = this;

      var eqAnswer = this.questionInfo.eqAnswer;
      var eqType = this.questionInfo.eqType;
      var bzAnswerInfo = "";

      if (eqType == 1 || eqType == 3 || eqType == 15) {
        //单选和判断题
        bzAnswerInfo = this.zmArr[eqAnswer];
      } else if (eqType == 2 || eqType == 10 || eqType == 8) {
        //多选和匹配题
        eqAnswer.forEach(function (element, index) {
          if (index > 0) {
            bzAnswerInfo += ",";
          }

          bzAnswerInfo += _this.zmArr[element];
        });
      } else if (eqType == 4) {
        eqAnswer.forEach(function (element, index) {
          if (index > 0) {
            bzAnswerInfo += ", ";
          }

          bzAnswerInfo += index + 1 + ":" + element;
        });
      } else if (eqType == 7) {
        bzAnswerInfo = eqAnswer;
      } else {
        bzAnswerInfo = eqAnswer;
      }

      return bzAnswerInfo;
    }
  },
  methods: {}
};